export default __webpack_public_path__ + "static/media/scattered-cards.12f3c5de.svg";